import { Box } from '@mui/material'
import { useRef } from 'react'
import { Editor } from '@tinymce/tinymce-react'

const inviteEmailTemplate = `<p>Welcome to Monark! 👋</p>
<p>We're excited you're here. You'll be using Monark to learn and practice critical leadership behaviors as you complete your learning path.&nbsp;</p>
<p>As you explore the app, you'll find plenty of learning opportunities. From exchanging feedback with peers to practicing having a difficult conversation with our AI role-play, Monark offers a range of features to support your growth.</p>
<p>Getting started is easy and won't take much time. Just click the link below to begin, whether you're using your computer or mobile device.</p>
<p>1) Create your account.</p>
<p>2) Select a learning path (if it isn't already selected for you).&nbsp;</p>
<p>3) Complete your self-assessment (this step is crucial as it provides you with a baseline understanding of where you are currently!).</p>
<p>4) Send out 360-degree assessments to your colleagues to help give you a balanced perspective on your strengths and potential blind spots before you begin.</p>
<p>If you have any troubles getting started, we've got you! Reach out to us at support@leadwithmonark.com.</p>
<p>And remember, using Monark is like going to the gym. You may not see results overnight, but stick with us, learn and practice regularly, and in time, your peers and company (and you!) will start to see the results of your consistency! It's habit-based growth ;)&nbsp;</p>
<p>Thanks for trusting us in supporting you. We'll always have your back when it comes to confidentiality. Now, let's get going. We're excited to start your leadership journey!&nbsp;</p>`
const RichTextContentEditor = ({
  data,
  changeCallback,
  emailEditor = false,
  inviteEmail = true,
  onFocusOut = () => {}
}) => {
  const editorRef = useRef(null)
  const handleChange = updated => {
    if (updated !== data) {
      changeCallback(updated)
    }
  }

  const toolbar =
    'undo redo table |' +
    (emailEditor ? '' : ' image') +
    ' link | fontsize bold italic forecolor backcolor | alignleft aligncenter ' +
    'alignright alignjustify | lists bullist numlist outdent indent | ' +
    'removeformat | help | code'

  return (
    <Box width='100%' minHeight='400px' sx={{ border: 'solid 1px' }}>
      <Editor
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={emailEditor && inviteEmail ? inviteEmailTemplate : data}
        onEditorChange={e => handleChange(e)}
        init={{
          height: 500,
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'table',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'autosave',
            'insertdatetime',
            'media',
            'table',
            'help',
            'wordcount'
          ],
          toolbar,
          font_size_formats: '8px 10px 12px 14px 16px 18px 24px 36px',
          autosave_ask_before_unload: false,
          content_style:
            'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
        }}
        onBlur={onFocusOut}
      />
    </Box>
  )
}

export default RichTextContentEditor
